import { ResetPasswordPage } from "@/features/auth/pages/ResetPassword";

const ResetPassword = () => {
  return <ResetPasswordPage />;
};

export default ResetPassword;
